import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import {
  BasicSelect
} from 'vue-search-select'
import Paginate from 'vuejs-paginate'
import moment from 'moment'

export default {
  name: 'change-bag-seal',
  components: {
    BasicSelect,
    Paginate,
    VueElementLoading
  },
  props: [],
  data() {
    return {
      isLoadingSearch: false,
      isLoading: false,
      hubzoneLoading: '',
      hubLoading: '',
      flthubLoading:'',
      palletNumber: '',
      hubzone: '',
      hub: '',
      RowListData: [],
      hubzonelist: [],
      hublist: [],
      hublistFlt: [],
      listHubZoneData: [],
      hubname: '',
      hubFlt: '',
      hubzoneidflt1: '',
      listHubZoneObjDataFlt1: {
        value: '',
        text: ''
      },
      hubzoneitem: {
        id: '',
        text: ''
      },
      hubitemFlt: {
        value: '',
        text: ''
      },
      hubitem: {
        value: '',
        text: ''
      },
      pageCount: 0,
      pageNo: 0,
      totalRows: 0,
      limit: 10,
      createdby:'',
			userHubid:'',
			updateModal:false,
			modaldata:'',
      hubzoneitemForUpdate:{
        value: '',
        text: ''
      },
      hubZoneForUpdate:'',
      hubItemForUpdate:{
        value: '',
        text: ''
      },
      hubNameForUpdate:'',
      palletNumberForUpdate:'',
      HubZoneListDataForUpdate:[],
      HubDetailsForUpdate:[],
      palletErrorMSG:'',
      palletNoError:false,
      hubZoneError:false,
      hubZoneErrorMsg:'',
      hubNameError:false,
      hubNameErrorMsg:'',
      regexForBinNum:/^[a-zA-Z0-9]{1,30}$/,
      statusmodal:false,
      modalDataForStatus:[]

    }
  },
  computed: {},
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY');
    }
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.createdby = userdetail[0].email
		this.userHubid = userdetail[0].HubId[0]
    this.getHubZone();

  },
  methods: {
    getHubZone() {
      this.hubzoneLoading = 'Loading Hub Zone...'
      var HubZoneListData = []
      this.input = ({})
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubzone/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubzoneLoading = ''
          if (result.data.ResultCode == 100) {
          HubZoneListData = result.data.ResponseData;
          for (var i = 0; i < HubZoneListData.length; i++) {
            this.hubzonelist.push({
              id: HubZoneListData[i].hubzoneid,
              text: HubZoneListData[i].hubzonename
            })
            this.listHubZoneData.push({
              id: HubZoneListData[i].hubzoneid,
              text: HubZoneListData[i].hubzonename
            })
          }
        }
        else{
          HubZoneListData = []
        }
        }, error => {
          this.hubzoneLoading = ''
          console.error(error)
        })
    },
    selectHubZoneForUpdate(hubzoneitem) {
      this.hubzoneitemForUpdate = hubzoneitem
      this.hubZoneForUpdate = this.hubzoneitemForUpdate.id
      this.hublist = []
      this.hubitem = {
        value: '',
        text: ''
      }
      this.hub = ''
      this.$validator.reset()
      if (this.hubZoneForUpdate != undefined) {
        this.getHubListForUpdate()
      }
    },
    selectHubZone(hubzoneitem) {
      this.hubzoneitem = hubzoneitem
      this.hubzone = this.hubzoneitem.text
      this.hubzoneid = this.hubzoneitem.id
      this.hublist = []
      this.hubitem = {
        value: '',
        text: ''
      }
      this.hub = ''
			this.$validator.reset()
      if (this.hubzoneid != undefined) {
        this.getHubList()
      }
    },
    selectedHubZoneFlt1(listHubZoneObjDataFlt1) {
      this.listHubZoneObjDataFlt1 = listHubZoneObjDataFlt1
      this.hubzoneidflt1 = listHubZoneObjDataFlt1.text
      this.hubzoneid = listHubZoneObjDataFlt1.id
      this.hublistFlt = []
      this.hubitemFlt = {
        value: '',
        text: ''
      }
      this.hubFlt = ''
			this.$validator.reset()
      if (this.hubzoneid != undefined) {
        this.getHubListForFilter('IsSearch')
      }
    },
    getHubList(type) {

		this.hubLoading = 'Loading Hub...'
    var hubzone = this.hubzoneitem.id
    this.hublist=[]
      var HubDetails = []
      this.input = ({
        hubZoneId: hubzone
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubLoading = ''
          this.flthubLoading = ''
          if (result.data.ResultCode == 100) {
            HubDetails = result.data.ResponseData
            for (var i = 0; i < HubDetails.length; i++) {
              this.hublist.push({
                "value": HubDetails[i].HubID,
                "text": HubDetails[i].HubName + '(' + HubDetails[i].HubID + ')',
              })

            }
          }else{
            HubDetails = []
          }
        }, error => {
          this.hubLoading = ''
          this.flthubLoading = ''
          console.error(error)
        })
    },
    getHubListForFilter(type) {
        this.flthubLoading = 'Loading Hub...'
        var hubzone = this.listHubZoneObjDataFlt1.id
      var HubDetails = []
      this.input = ({
        hubZoneId: hubzone
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.flthubLoading = ''
          if (result.data.ResultCode == 100) {
            HubDetails = result.data.ResponseData
            for (var i = 0; i < HubDetails.length; i++) {

              this.hublistFlt.push({
                "value": HubDetails[i].HubID,
                "text": HubDetails[i].HubName + '(' + HubDetails[i].HubID + ')',
              })
            }
          }else{
            HubDetails = []
          }
        }, error => {
          this.hubLoading = ''
          this.flthubLoading = ''
          console.error(error)
        })
    },
    getHubListForUpdate(type) {
      this.hubItemForUpdate={
        value: '',
        text: ''
      }
      this.hubNameForUpdate=''
      this.hubLoading = 'Loading Hub...'
      var hubzone = this.hubZoneForUpdate
      this.HubDetailsForUpdate=[]

      var HubDetails = []
      this.input = ({
        hubZoneId: hubzone
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubLoading = ''
          if (result.data.ResultCode == 100) {
            HubDetails = result.data.ResponseData
            for (var i = 0; i < HubDetails.length; i++) {
              this.HubDetailsForUpdate.push({
                "value": HubDetails[i].HubID,
                "text": HubDetails[i].HubName + '(' + HubDetails[i].HubID + ')',
              })
            }
          }else{
            HubDetails = []
          }
        }, error => {
          this.hubLoading = ''
          this.flthubLoading = ''
          console.error(error)
        })
    },

    selectHub(hubitem) {
      this.hubitem = hubitem
      this.hub = hubitem.text
    },
    selectHubForUpdate(hubitem) {
      this.hubItemForUpdate = hubitem
      this.hubNameForUpdate = hubitem.value
    },
    selectHubFlt(hubitem) {
      this.hubitemFlt = hubitem
      this.hubFlt = hubitem.text
    },
    createPallet() {
      this.isLoading = true;
      this.input = ({
        "palletNumber": this.palletNumber,
        "hubId": this.hubitem.value,
        "createdBy": this.createdby,
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'addNewPallet',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.isLoading = false;
          if (result.data.ResultCode == 100) {
            this.$alert(result.data.ReturnMessage, "", "success");

            this.resetForm();

          } else {
            //  this.$alertify.error(result.data.ReturnMessage)
            this.$alert(result.data.ReturnMessage, "", "error");
          }
        }, error => {
          console.error(error)
        })
    },
    updatePallet() {
      if(!this.hubNameForUpdate)
      {
        this.hubNameError=true;
        this.hubNameErrorMsg='Select Hub Name';
      }
      if(!this.palletNumberForUpdate)
      {
        this.palletNoError=true;
        this.palletErrorMSG='Enter Pallet Number';
      }

      if(!this.hubNameForUpdate || !this.palletNumberForUpdate)
      {
        return false;
      }
      if(this.regexForBinNum.test(this.palletNumberForUpdate) == false)
      {
        this.palletNoError=true;
        this.palletErrorMSG="Pallet Number Must Be AlphaNumeric";
        return false;
      }
      this.input = ({
        "palletId": this.modaldata.palletid,
        "palletNumber": this.palletNumberForUpdate,
        "hubId": this.hubNameForUpdate,
        "palletStatus": this.modaldata.palletstatus,
        "isActive": this.modaldata.isactive,
        "LastModifiedBy": this.createdby
      })
      axios({
          method: 'PUT',
          'url': apiUrl.api_url_hubops + 'updatePallet',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.$alert(result.data.ReturnMessage, "", "success");
            this.closeUpdatePalletModal();
          } else {
            this.$alert(result.data.ReturnMessage, "", "error");
          }
        }, error => {
          console.error(error)
        })
    },
    resetFlt() {
      this.totalRows=0
      this.RowListData=[]
      this.hubzoneidflt1 = ''
      this.hubFlt = '',
        this.hubitemFlt = {
          value: '',
          text: ''
        },
        this.listHubZoneObjDataFlt1 = {
          value: '',
          text: ''
        }
        this.$validator.reset();
    },
    resetForm() {
      this.totalRows = 0;
      this.pageCount = 0;
      this.hubzone = "";
      this.hub = "";
      this.palletNumber = "";
      this.hubzoneitem = {
          id: '',
          text: ''
        },
        this.hubitem = {
          value: '',
          text: ''
        },
        this.$validator.reset();
    },
    getPalletList() {
      this.isLoadingSearch = true;
      this.input = ({});
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + 'listPalletMaster?hubId=' + this.hubitemFlt.value + '&offset=' + this.pageNo + '&limit=' + this.limit,
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.isLoadingSearch = false;
          if (result.data.ResultCode == 100) {
            this.RowListData = result.data.ResponseData;
            this.totalRows = result.data.TotalCount
            if (this.totalRows < 10) {
              this.pageCount = 1
            } else {
              this.pageCount = Math.ceil(this.totalRows / 10);
            }
          } else {
						this.RowListData = []
						this.totalRows = 0
          }

        }, error => {
          this.isLoadingSearch = false;
          console.error(error)
        })
    },
    getPaginationData(pageNum) {
      this.pageNo = (pageNum - 1)
      this.getPalletList()
    },
		openUpdatePalletModal(data){
      this.hubNameForUpdate=data.hubid,
      this.palletNumberForUpdate=data.palletnumber
      this.hubzoneLoading = 'Loading Hub Zone...'
      if(data.hubid)
      {
        this.input = ({
          id: data.hubid
        })
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/hub/get',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubzoneLoading = ''
          if (result.data.ResultCode == 100) {
          this.HubZoneListDataForUpdate = result.data.ResponseData[0];
          this.hubItemForUpdate={
            value: this.HubZoneListDataForUpdate.HubID,
            text: this.HubZoneListDataForUpdate.HubName
          };
          this.hubzoneitemForUpdate={
            value: this.HubZoneListDataForUpdate.HubZoneId,
            text: this.HubZoneListDataForUpdate.hubzonename
          };
        }
        else{
          this.HubZoneListDataForUpdate = []
        }
        }, error => {
          this.hubzoneLoading = ''
          console.error(error)
        })

			this.updateModal = true
			this.modaldata = data

		},
		closeUpdatePalletModal(){
      this.palletErrorMSG='',
      this.palletNumber='',
			this.updateModal = false
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
			this.getPalletList()
		},
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return false;
        } else {
          this.createPallet();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    onSubmitFlt: function(Flt) {
      this.$validator.validateAll('Flt').then((result) => {
        if (!result) {
          return false;
        } else {
          this.getPalletList();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    openStatusModal(data) {
      this.statusmodal = true
      this.modalDataForStatus = data
    },
    closeStatusModal() {
      this.statusmodal = false,
      this.modalDataForStatus=[],
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
      this.getPalletList()

    },
    updatePalletStatus(){
      var newStatus=this.modalDataForStatus.isactive?0:1;
      this.input = ({
        "palletId": this.modalDataForStatus.palletid,
        "isActive": newStatus,
        "LastModifiedBy":this.createdby
      })
      axios({
          method: 'PUT',
          'url': apiUrl.api_url_hubops + 'updatePalletStatus',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.$alert(result.data.ReturnMessage, "", "success");
            this.closeStatusModal();
          } else {
            this.$alert(result.data.ReturnMessage, "", "error");
          }
        }, error => {
          console.error(error)
        })

    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/palletMaster/palletMaster.js